import { render } from "./FilialsForm.vue?vue&type=template&id=12efa67c&scoped=true"
import script from "./FilialsForm.vue?vue&type=script&lang=js"
export * from "./FilialsForm.vue?vue&type=script&lang=js"

import "./FilialsForm.vue?vue&type=style&index=0&id=12efa67c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12efa67c"]])

export default __exports__